/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  block-scoped-var,
  import/no-extraneous-dependencies,
  no-redeclare,
  no-var,
  vars-on-top
*/
import React from 'react';
import classNames from 'classnames';
import createReactClass from 'create-react-class';
import HfReactHelper from 'common/utils/hf-react-helper';
import CheckMark from './pricing-levels/checkmark';

const PricingLevelFeature = createReactClass({
  render() {
    const containerClasses = classNames({
      'm-pricing-level--feature': true,
      'small-12': true,
      columns: true,
      block: true,
      expanded: this.props.expanded,
      'main-feature': this.props.key === 'main-feature',
    });

    let primaryColor = 'c-cerulean';
    let trueColor = '#00B3E6';

    if (HfReactHelper.isHelloFax()) {
      primaryColor = 'c-goldenrod';
      trueColor = '#F59600';
    }

    const numberClasses = classNames({
      number: true,
      [primaryColor]: true,
    });

    let nameClasses = 'name';
    if (this.props.removeCheckMark) {
      nameClasses += ' bold';
    }

    const name = (<div className={nameClasses}>{this.props.name}</div>);
    const number = (<div className={numberClasses}>{this.props.number}</div>);
    const detail = (<div className='detail'>{this.props.detail}</div>);
    const check = (<div className='checkmark'><CheckMark color={trueColor} /></div>);

    // Add a check mark if you have a feature with a detail but no no name or number
    //  and this isn't the detail for the looking for more? section
    //  (as denoted by removeCheckMark = true)
    let hasCheckMark = false;
    if (
      !this.props.detail && !this.props.number
      && this.props.name
      && !this.props.removeCheckMark
    ) {
      hasCheckMark = true;
    }

    return (
      <div className={containerClasses}>
        {number}
        {hasCheckMark
        && check
        }
        {name}
        {detail}
      </div>
    );
  },
});

module.exports = PricingLevelFeature;
